// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"99eaeb2a","691":"b6ff71b0","897":"5e015f17"}[chunkId] + ".chunk.js";
};